/* ==========================================================================
   HP LAB — hp-quick-search-controller.js
   ÚNICA pieza que toca el DOM del buscador rápido. Se auto-inyecta en
   cualquier página que lo cargue (modal + botón flotante persistente), sin
   depender de dónde esté colocado el snippet en el theme.

   No conoce el diagnóstico. No modifica hp-diagnostico-controller.js ni
   comparte su estado — módulo completamente independiente, como pide la
   especificación.

   Cualquier elemento en cualquier página puede abrir este buscador
   agregándole el atributo data-hp-quick-search-trigger — no requiere
   wiring adicional.
   ========================================================================== */
window.HPQuickSearch = window.HPQuickSearch || {};

(function () {
  "use strict";

  var ICONS = {
    search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>',
    battery: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="17" height="10" rx="2"/><path d="M21 10v4"/><path d="M8 9l0 6M12 9l0 6" opacity="0"/></svg>',
    charger: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2v4M15 2v4M6 8h12v4a6 6 0 0 1-6 6 6 6 0 0 1-6-6V8z"/><path d="M12 18v4"/></svg>',
    whatsapp: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.5 8.5 0 0 1-12.5 7.5L3 20l1.1-5.4A8.5 8.5 0 1 1 21 11.5z"/></svg>',
    camera: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l2-2h6l2 2h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 5 5L19 7"/></svg>',
    back: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    alert: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v.01M12 8v5"/></svg>'
  };

  var OPTIONAL_FIELDS = {
    battery: [
      { key: "model", label: "Modelo completo", placeholder: "Ej: 15-eg0000" },
      { key: "productNumber", label: "Product Number / P/N", placeholder: "Ej: 4X2K5LA" },
      { key: "serial", label: "Número de serie", placeholder: "Ej: 5CD1234567" },
      { key: "batteryPartNumber", label: "Part number de la batería", placeholder: "Ej: L11M4P02" },
      { key: "otherData", label: "Otro dato relevante", placeholder: "Cualquier otro dato que ayude a identificarla" }
    ],
    charger: [
      { key: "model", label: "Modelo del notebook", placeholder: "Ej: Pavilion 14" },
      { key: "productNumber", label: "Product Number / P/N", placeholder: "Ej: HSTNN-DB8K" },
      { key: "voltage", label: "Voltaje", placeholder: "Ej: 19.5 V" },
      { key: "amperage", label: "Amperaje", placeholder: "Ej: 3.33 A" },
      { key: "connector", label: "Tipo de conector", placeholder: "Ej: Punta azul 4.5 x 3.0 mm / USB-C" },
      { key: "otherData", label: "Otro dato relevante", placeholder: "Cualquier otro dato que ayude a identificarlo" }
    ]
  };

  var state = {
    productType: null,
    brandKey: null,
    brandLabel: null,
    family: null,
    wattage: null,
    model: "",
    productNumber: "",
    serial: "",
    batteryPartNumber: "",
    voltage: "",
    amperage: "",
    connector: "",
    otherData: "",
    photo: null
  };

  var config = null;
  var configPromise = null;
  var els = {};
  var mounted = false;
  var settings = { whatsappNumber: "", configUrl: "", batteryIconUrl: "", chargerIconUrl: "" };

  function resetState() {
    state = {
      productType: null, brandKey: null, brandLabel: null, family: null, wattage: null,
      model: "", productNumber: "", serial: "", batteryPartNumber: "",
      voltage: "", amperage: "", connector: "", otherData: "", photo: null
    };
  }

  function trackEvent(name, data) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(Object.assign({ event: "hp_quick_search_" + name }, data || {}));
      }
    } catch (e) { /* la analítica nunca debe romper el flujo */ }
  }

  function loadConfig() {
    if (configPromise) return configPromise;
    configPromise = fetch(settings.configUrl)
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (json) { config = json; return json; });
    return configPromise;
  }

  function showError(message) {
    if (els.error) {
      els.error.textContent = message;
      els.error.hidden = false;
    }
  }
  function hideError() {
    if (els.error) els.error.hidden = true;
  }

  /* ------------------------------------------------------------------ *
   * Inyección del modal + botón flotante — se ejecuta UNA vez por página
   * ------------------------------------------------------------------ */
  function mount() {
    if (mounted) return;
    mounted = true;

    var wrap = document.createElement("div");
    wrap.className = "hp-qs";
    wrap.innerHTML =
      '<div class="hp-qs-overlay" data-hp-qs-overlay hidden>' +
        '<div class="hp-qs-modal" role="dialog" aria-modal="true" aria-label="Buscador rápido de repuestos compatibles">' +
          '<button type="button" class="hp-qs-close" data-hp-qs-close aria-label="Cerrar">' + ICONS.close + "</button>" +
          '<div class="hp-qs-header">' +
            '<span class="hp-qs-header__icon">' + ICONS.search + "</span>" +
            '<div><h2>Busquemos tu repuesto compatible</h2><p>Selecciona si buscas una batería o un cargador y completa solo los datos que conozcas.</p></div>' +
          "</div>" +
          '<p class="hp-qs-helper">' + ICONS.alert + "<span>Ningún campo es obligatorio. Mientras más información ingreses, mejor será la búsqueda.</span></p>" +

          '<div class="hp-qs-body" data-hp-qs-body>' +

            '<div class="hp-qs-type-grid" data-hp-qs-type-grid>' +
              '<button type="button" class="hp-qs-type-card" data-hp-qs-type="battery">' +
                '<span class="hp-qs-type-card__check">' + ICONS.check + "</span>" +
                '<span class="hp-qs-type-card__icon">' + (settings.batteryIconUrl ? '<img src="' + settings.batteryIconUrl + '" alt="Batería">' : ICONS.battery) + "</span>" +
                '<span class="hp-qs-type-card__title">Batería</span>' +
                '<span class="hp-qs-type-card__desc">Encuentra baterías compatibles con tu notebook</span>' +
              "</button>" +
              '<button type="button" class="hp-qs-type-card" data-hp-qs-type="charger">' +
                '<span class="hp-qs-type-card__check">' + ICONS.check + "</span>" +
                '<span class="hp-qs-type-card__icon">' + (settings.chargerIconUrl ? '<img src="' + settings.chargerIconUrl + '" alt="Cargador">' : ICONS.charger) + "</span>" +
                '<span class="hp-qs-type-card__title">Cargador</span>' +
                '<span class="hp-qs-type-card__desc">Encuentra cargadores compatibles con tu notebook</span>' +
              "</button>" +
            "</div>" +

            '<div class="hp-qs-tree" data-hp-qs-tree hidden>' +
              '<div class="hp-qs-field-block">' +
                '<label>Marca</label>' +
                '<div class="hp-qs-chip-grid" data-hp-qs-brand-grid></div>' +
              "</div>" +

              '<div class="hp-qs-field-block" data-hp-qs-detail-block>' +
                '<label data-hp-qs-detail-label>Familia o línea</label>' +
                '<div class="hp-qs-chip-grid" data-hp-qs-detail-grid>' +
                  '<p class="hp-qs-empty-hint" data-hp-qs-detail-hint>Elige una marca para ver las opciones.</p>' +
                "</div>" +
              "</div>" +

              '<details class="hp-qs-optional" data-hp-qs-optional>' +
                '<summary>Agregar más datos para mejorar la búsqueda</summary>' +
                '<p class="hp-qs-optional__hint">Completa solamente lo que conozcas.</p>' +
                '<div class="hp-qs-optional__fields" data-hp-qs-optional-fields></div>' +
                '<label class="hp-qs-upload-zone" data-hp-qs-upload-zone>' +
                  '<span class="hp-qs-upload-zone__icon">' + ICONS.camera + "</span>" +
                  '<span class="hp-qs-upload-zone__text">Sube una foto de la etiqueta (opcional)</span>' +
                  '<span class="hp-qs-upload-zone__sub">JPG, PNG · Máx. 5 MB</span>' +
                  '<input type="file" accept="image/*" data-hp-qs-photo-input>' +
                "</label>" +
                '<div class="hp-qs-upload-preview" data-hp-qs-upload-preview hidden>' +
                  '<img data-hp-qs-upload-preview-img alt="Vista previa">' +
                  '<span data-hp-qs-upload-preview-name></span>' +
                  '<button type="button" data-hp-qs-upload-remove>Eliminar</button>' +
                "</div>" +
              "</details>" +

              '<p class="hp-qs-error" data-hp-qs-error hidden></p>' +

              '<div class="hp-qs-actions">' +
                '<button type="button" class="hp-qs-btn hp-qs-btn--primary" data-hp-qs-search>' +
                  ICONS.search + '<span data-hp-qs-search-label>Ver compatibles</span>' +
                "</button>" +
                '<button type="button" class="hp-qs-btn hp-qs-btn--whatsapp" data-hp-qs-whatsapp>' +
                  ICONS.whatsapp + "Comunícate con un agente" +
                "</button>" +
              "</div>" +
              '<p class="hp-qs-whatsapp-hint"><span data-hp-qs-whatsapp-hint-text>Si no encuentras tu repuesto, te ayudamos por WhatsApp.</span></p>' +

              '<button type="button" class="hp-qs-change-type" data-hp-qs-change-type>' + ICONS.back + " Elegir otro tipo de producto</button>" +
            "</div>" +

            '<div class="hp-qs-results" data-hp-qs-results hidden>' +
              '<button type="button" class="hp-qs-change-type" data-hp-qs-back-to-form>' + ICONS.back + " Modificar búsqueda</button>" +
              '<h3 class="hp-qs-results-count" data-hp-qs-results-count hidden></h3>' +
              '<div class="hp-qs-confirm-banner" data-hp-qs-confirm-banner hidden>' +
                ICONS.alert + '<span>Estos resultados requieren confirmación de compatibilidad con un agente antes de comprar.</span>' +
                '<button type="button" class="hp-qs-btn hp-qs-btn--sm hp-qs-btn--whatsapp-ghost" data-hp-qs-whatsapp>Derivar a agente</button>' +
              "</div>" +
              '<div class="hp-qs-product-grid" data-hp-qs-product-grid hidden></div>' +
              '<div class="hp-qs-no-results" data-hp-qs-no-results hidden>' +
                '<h3>No encontramos una coincidencia exacta con esos datos.</h3>' +
                '<p>Puedes adjuntar una foto de la etiqueta directamente en WhatsApp.</p>' +
                '<div class="hp-qs-no-results__actions">' +
                  '<button type="button" class="hp-qs-btn hp-qs-btn--ghost" data-hp-qs-back-to-form>Modificar búsqueda</button>' +
                  '<button type="button" class="hp-qs-btn hp-qs-btn--ghost" data-hp-qs-view-all>Ver todos los productos de esta categoría</button>' +
                  '<button type="button" class="hp-qs-btn hp-qs-btn--whatsapp" data-hp-qs-whatsapp>' + ICONS.whatsapp + "Consultar con un agente</button>" +
                "</div>" +
              "</div>" +
            "</div>" +

          "</div>" +
        "</div>" +
      "</div>" +
      '<button type="button" class="hp-qs-fab" data-hp-quick-search-trigger data-hp-qs-fab>' +
        ICONS.search + '<span>Buscar batería o cargador</span>' +
      "</button>";

    document.body.appendChild(wrap);

    els.overlay = wrap.querySelector("[data-hp-qs-overlay]");
    els.body = wrap.querySelector("[data-hp-qs-body]");
    els.typeGrid = wrap.querySelector("[data-hp-qs-type-grid]");
    els.tree = wrap.querySelector("[data-hp-qs-tree]");
    els.brandGrid = wrap.querySelector("[data-hp-qs-brand-grid]");
    els.detailBlock = wrap.querySelector("[data-hp-qs-detail-block]");
    els.detailLabel = wrap.querySelector("[data-hp-qs-detail-label]");
    els.detailGrid = wrap.querySelector("[data-hp-qs-detail-grid]");
    els.detailHint = wrap.querySelector("[data-hp-qs-detail-hint]");
    els.optionalFields = wrap.querySelector("[data-hp-qs-optional-fields]");
    els.optionalDetails = wrap.querySelector("[data-hp-qs-optional]");
    els.error = wrap.querySelector("[data-hp-qs-error]");
    els.searchBtn = wrap.querySelector("[data-hp-qs-search]");
    els.searchLabel = wrap.querySelector("[data-hp-qs-search-label]");
    els.whatsappHintText = wrap.querySelector("[data-hp-qs-whatsapp-hint-text]");
    els.results = wrap.querySelector("[data-hp-qs-results]");
    els.resultsCount = wrap.querySelector("[data-hp-qs-results-count]");
    els.confirmBanner = wrap.querySelector("[data-hp-qs-confirm-banner]");
    els.productGrid = wrap.querySelector("[data-hp-qs-product-grid]");
    els.noResults = wrap.querySelector("[data-hp-qs-no-results]");
    els.uploadZone = wrap.querySelector("[data-hp-qs-upload-zone]");
    els.uploadInput = wrap.querySelector("[data-hp-qs-photo-input]");
    els.uploadPreview = wrap.querySelector("[data-hp-qs-upload-preview]");
    els.uploadPreviewImg = wrap.querySelector("[data-hp-qs-upload-preview-img]");
    els.uploadPreviewName = wrap.querySelector("[data-hp-qs-upload-preview-name]");
    els.fab = wrap.querySelector("[data-hp-qs-fab]");

    wireEvents(wrap);
  }

  /* ------------------------------------------------------------------ *
   * Render
   * ------------------------------------------------------------------ */
  function renderBrands() {
    if (!config || !state.productType || !els.brandGrid) return;
    var brands = config.brands || [];
    els.brandGrid.innerHTML = brands.map(function (b) {
      var pressed = state.brandLabel === b;
      return '<button type="button" class="hp-qs-chip" data-hp-qs-brand="' + b.replace(/"/g, "&quot;") + '" data-hp-qs-brand-label="' + b.replace(/"/g, "&quot;") + '" aria-pressed="' + pressed + '">' + b + "</button>";
    }).join("");
  }

  function renderDetail() {
    if (!els.detailGrid) return;
    if (state.productType === "battery") {
      els.detailLabel.textContent = "Familia o línea";
      var families = state.brandLabel && config.families ? config.families[state.brandLabel] : null;
      if (!families) {
        els.detailGrid.innerHTML = '<p class="hp-qs-empty-hint" data-hp-qs-detail-hint>Elige una marca para ver las opciones.</p>';
        return;
      }
      els.detailGrid.innerHTML = families.map(function (f) {
        var pressed = state.family === f;
        return '<button type="button" class="hp-qs-chip" data-hp-qs-family="' + f.replace(/"/g, "&quot;") + '" aria-pressed="' + pressed + '">' + f + "</button>";
      }).join("");
    } else if (state.productType === "charger") {
      els.detailLabel.textContent = "Potencia";
      var wattages = (config && config.wattages) || [];
      els.detailGrid.innerHTML = wattages.map(function (w) {
        var pressed = String(state.wattage) === String(w);
        return '<button type="button" class="hp-qs-chip" data-hp-qs-wattage="' + w + '" aria-pressed="' + pressed + '">' + w + " W</button>";
      }).join("");
    }
  }

  function renderOptionalFields() {
    var fields = OPTIONAL_FIELDS[state.productType] || [];
    els.optionalFields.innerHTML = fields.map(function (f) {
      return '<div class="hp-qs-field">' +
        '<label for="hp-qs-' + f.key + '">' + f.label + "</label>" +
        '<input type="text" id="hp-qs-' + f.key + '" data-hp-qs-field="' + f.key + '" placeholder="' + f.placeholder.replace(/"/g, "&quot;") + '" value="' + (state[f.key] || "").replace(/"/g, "&quot;") + '">' +
      "</div>";
    }).join("");
  }

  function renderSearchLabel() {
    els.searchLabel.textContent = state.productType === "battery" ? "Ver baterías compatibles" : "Ver cargadores compatibles";
    if (els.whatsappHintText) {
      els.whatsappHintText.textContent = state.productType === "battery"
        ? "Si no encuentras tu batería, te ayudamos por WhatsApp."
        : "Si no encuentras tu cargador, te ayudamos por WhatsApp.";
    }
  }

  function showTypeStep() {
    els.tree.hidden = true;
    els.results.hidden = true;
    els.typeGrid.hidden = false;
    var cards = els.typeGrid.querySelectorAll("[data-hp-qs-type]");
    cards.forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
  }

  function showTreeStep() {
    els.typeGrid.hidden = true;
    els.results.hidden = true;
    els.tree.hidden = false;
    renderBrands();
    renderDetail();
    renderOptionalFields();
    renderSearchLabel();
    hideError();
  }

  function showResultsStep() {
    els.typeGrid.hidden = true;
    els.tree.hidden = true;
    els.results.hidden = false;
    scrollToResults();
  }

  /* ------------------------------------------------------------------ *
   * Foto
   * ------------------------------------------------------------------ */
  function handlePhotoFile(file) {
    if (!file || !/^image\//.test(file.type)) return;
    var reader = new FileReader();
    reader.onload = function () {
      state.photo = { name: file.name, dataUrl: reader.result };
      els.uploadPreviewImg.src = reader.result;
      els.uploadPreviewName.textContent = file.name;
      els.uploadPreview.hidden = false;
      els.uploadZone.hidden = true;
    };
    reader.readAsDataURL(file);
  }

  function clearPhoto() {
    state.photo = null;
    if (els.uploadInput) els.uploadInput.value = "";
    els.uploadPreview.hidden = true;
    els.uploadZone.hidden = false;
  }

  /* ------------------------------------------------------------------ *
   * WhatsApp — mensaje simple, solo campos completados, sin líneas vacías
   * ------------------------------------------------------------------ */
  function buildWhatsappMessage(noMatch) {
    var isBattery = state.productType === "battery";
    var lines = [];
    lines.push(isBattery
      ? "Hola, necesito ayuda para encontrar una batería compatible."
      : "Hola, necesito ayuda para encontrar un cargador compatible.");
    if (state.brandLabel) lines.push("Marca: " + state.brandLabel);
    if (isBattery && state.family) lines.push("Familia o modelo: " + state.family);
    if (!isBattery && state.wattage) lines.push("Potencia: " + state.wattage + " W");
    if (state.model) lines.push("Modelo: " + state.model);
    if (state.productNumber) lines.push("Product Number: " + state.productNumber);
    if (isBattery && state.batteryPartNumber) lines.push("Part number de batería: " + state.batteryPartNumber);
    if (isBattery && state.serial) lines.push("Número de serie: " + state.serial);
    if (!isBattery && state.voltage) lines.push("Voltaje: " + state.voltage);
    if (!isBattery && state.amperage) lines.push("Amperaje: " + state.amperage);
    if (!isBattery && state.connector) lines.push("Conector: " + state.connector);
    if (state.otherData) lines.push("Otro dato: " + state.otherData);
    if (noMatch) lines.push("No encontré una coincidencia exacta.");
    if (state.photo) lines.push("Puedo adjuntar una foto de la etiqueta en este chat.");
    return lines.join("\n");
  }

  function openWhatsapp(noMatch) {
    try {
      var number = window.HPLab && HPLab.SearchEngine && HPLab.SearchEngine.normalizePhone
        ? HPLab.SearchEngine.normalizePhone(settings.whatsappNumber)
        : clean(settings.whatsappNumber);
      if (!number) {
        showError("No se pudo abrir WhatsApp: falta configurar el número en la sección del buscador rápido.");
        return;
      }
      trackEvent("whatsapp_click", { stage: state.productType || "sin_tipo" });
      var message = buildWhatsappMessage(noMatch);
      var url = "https://wa.me/" + number + "?text=" + encodeURIComponent(message);
      window.open(url, "_blank", "noopener");
    } catch (err) {
      console.error("HP LAB Quick Search: error al abrir WhatsApp.", err);
      showError("No se pudo abrir WhatsApp. Intenta nuevamente.");
    }
  }

  function clean(v) { return (v || "").toString().trim(); }

  /* ------------------------------------------------------------------ *
   * Búsqueda — llama DIRECTO al motor único (HPLab.SearchEngine),
   * compartido con el diagnóstico. Este archivo ya no tiene su propio
   * ranking, filtro de marca, fallback ni normalización.
   * ------------------------------------------------------------------ */
  function runSearch() {
    hideError();
    if (!state.productType) return;

    if (!window.HPLab || !HPLab.SearchEngine || typeof HPLab.SearchEngine.search !== "function") {
      showError("El buscador no cargó correctamente (falta hp-search-engine.js o el orden de carga es incorrecto).");
      return;
    }
    if (!config || !config.collections) {
      showError("La configuración de búsqueda todavía no cargó. Espera un segundo y vuelve a intentar.");
      return;
    }

    var isBattery = state.productType === "battery";
    var collectionHandle = config.collections[state.productType];
    var originalLabel = els.searchLabel.textContent;
    els.searchBtn.setAttribute("disabled", "true");
    els.searchLabel.textContent = "Buscando…";

    trackEvent("search_click", { product_type: state.productType, brand: state.brandLabel || "", detail: state.family || state.wattage || "" });

    HPLab.SearchEngine.search({
      component: state.productType,
      collectionHandle: collectionHandle,
      brandsList: config.brands,
      brand: state.brandLabel,
      family: isBattery ? state.family : "",
      wattage: !isBattery ? state.wattage : "",
      model: state.model,
      productNumber: state.productNumber,
      serial: isBattery ? state.serial : "",
      partNumber: isBattery ? state.batteryPartNumber : "",
      voltage: !isBattery ? state.voltage : "",
      amperage: !isBattery ? state.amperage : "",
      connector: !isBattery ? state.connector : "",
      freeText: state.otherData
    }).then(function (result) {
      els.searchBtn.removeAttribute("disabled");
      els.searchLabel.textContent = originalLabel;
      renderResults(result.products, result.source);
      trackEvent(result.products && result.products.length ? "results_found" : "no_results", { product_type: state.productType });
      showResultsStep();
    }).catch(function (err) {
      console.error("HP LAB Quick Search: error al buscar.", err);
      els.searchBtn.removeAttribute("disabled");
      els.searchLabel.textContent = originalLabel;
      showError("No pudimos completar la búsqueda en este momento. Puedes intentarlo nuevamente o consultar con un agente.");
    });
  }

  /* "Ver todos los productos de la categoría" — acción explícita y
     separada, nunca automática. */
  function browseCategory() {
    hideError();
    if (!state.productType || !config || !config.collections) return;
    if (!window.HPLab || !HPLab.SearchEngine || typeof HPLab.SearchEngine.browseCollection !== "function") {
      showError("El buscador no cargó correctamente (falta hp-search-engine.js).");
      return;
    }
    var collectionHandle = config.collections[state.productType];
    trackEvent("browse_category", { product_type: state.productType });
    HPLab.SearchEngine.browseCollection(collectionHandle).then(function (result) {
      renderResults(result.products, result.source);
      showResultsStep();
    }).catch(function (err) {
      console.error("HP LAB Quick Search: error al mostrar la categoría completa.", err);
      showError("No pudimos cargar el catálogo completo en este momento.");
    });
  }

  /* Desplazamiento + resaltado tras finalizar la búsqueda — capa de
     presentación pura. No toca estado, filtros ni generación de resultados. */
  var highlightStyleInjected = false;
  function ensureHighlightStyle() {
    if (highlightStyleInjected) return;
    highlightStyleInjected = true;
    var style = document.createElement("style");
    style.textContent =
      ".hp-qs-results-highlight{outline:3px solid var(--hp-blue-soft,#56C4FF);outline-offset:4px;border-radius:14px;transition:outline-color .3s ease;}";
    document.head.appendChild(style);
  }

  function scrollToResults() {
    var target = els.noResults.hidden ? els.productGrid : els.noResults;
    if (!target) return;
    ensureHighlightStyle();
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      target.classList.add("hp-qs-results-highlight");
      window.setTimeout(function () {
        target.classList.remove("hp-qs-results-highlight");
      }, 1500);
    });
  }

  function renderResults(products, source) {
    var tierLabel = { recommended: "Coincidencia recomendada", compatible: "Compatible según los datos ingresados", confirm: "Requiere confirmación" };

    if (!products || !products.length) {
      if (els.resultsCount) els.resultsCount.hidden = true;
      els.productGrid.hidden = true;
      els.confirmBanner.hidden = true;
      els.noResults.hidden = false;
      return;
    }

    els.noResults.hidden = true;
    els.productGrid.hidden = false;
    if (els.resultsCount) {
      var count = products.length;
      els.resultsCount.textContent = "Encontramos " + count + (count === 1 ? " opción compatible" : " opciones compatibles");
      els.resultsCount.hidden = false;
    }
    var allConfirm = products.every(function (p) { return p.tier === "confirm"; });
    els.confirmBanner.hidden = !(source === "collection-browse" || allConfirm);

    els.productGrid.innerHTML = products.map(function (p) {
      return '<div class="hp-qs-product-card">' +
        '<div class="hp-qs-product-card__media">' +
          (p.image ? '<img src="' + p.image + '" alt="' + (p.title || "").replace(/"/g, "&quot;") + '" loading="lazy">' : "") +
          '<span class="hp-qs-product-card__tag hp-qs-product-card__tag--' + p.tier + '">' + tierLabel[p.tier] + "</span>" +
        "</div>" +
        '<div class="hp-qs-product-card__body">' +
          (p.brand ? '<div class="hp-qs-product-card__brand">' + p.brand + "</div>" : "") +
          '<div class="hp-qs-product-card__title">' + (p.title || "") + "</div>" +
          (p.price ? '<div class="hp-qs-product-card__price">$' + p.price + "</div>" : "") +
          '<div class="hp-qs-product-card__foot">' +
            '<a class="hp-qs-btn hp-qs-btn--ghost hp-qs-btn--sm" href="' + p.url + '">Ver producto</a>' +
            (p.available ? '<a class="hp-qs-btn hp-qs-btn--primary hp-qs-btn--sm" href="' + p.url + '">Comprar</a>' : "") +
          "</div>" +
        "</div>" +
      "</div>";
    }).join("");
  }

  /* ------------------------------------------------------------------ *
   * Abrir / cerrar
   * ------------------------------------------------------------------ */
  function open() {
    mount();
    loadConfig().then(function () {
      els.overlay.hidden = false;
      document.body.style.overflow = "hidden";
      trackEvent("open", {});
      if (!state.productType) {
        showTypeStep();
      } else {
        showTreeStep();
      }
    }).catch(function (err) {
      console.error("HP LAB Quick Search: error al cargar la configuración.", err);
      mount();
      els.overlay.hidden = false;
      document.body.style.overflow = "hidden";
      showError("No se pudo cargar la configuración del buscador (hp-search-config.json). Puedes consultar directamente con un agente.");
      showTypeStep();
    });
  }

  /* Puente desde el diagnóstico: abre el buscador flotante directo en el
     paso de árbol (sin pasar por "elegir tipo de producto"), con los datos
     que el usuario ya escribió en el diagnóstico. Así el diagnóstico no
     necesita mantener su propio motor de búsqueda activo en pantalla —
     reutiliza el mismo buscador que ya funciona. */
  function openWithPrefill(prefill) {
    prefill = prefill || {};
    mount();
    loadConfig().then(function () {
      if (prefill.productType) state.productType = prefill.productType;
      if (prefill.brand) state.brandLabel = prefill.brand;
      if (prefill.family) state.family = prefill.family;
      if (prefill.wattage) state.wattage = prefill.wattage;
      if (prefill.model) state.model = prefill.model;
      if (prefill.productNumber) state.productNumber = prefill.productNumber;
      if (prefill.serial) state.serial = prefill.serial;
      if (prefill.batteryPartNumber) state.batteryPartNumber = prefill.batteryPartNumber;
      if (prefill.voltage) state.voltage = prefill.voltage;
      if (prefill.amperage) state.amperage = prefill.amperage;
      if (prefill.connector) state.connector = prefill.connector;

      els.overlay.hidden = false;
      document.body.style.overflow = "hidden";
      trackEvent("open", { prefilled: true });
      if (state.productType) {
        showTreeStep();
      } else {
        showTypeStep();
      }
    }).catch(function (err) {
      console.error("HP LAB Quick Search: error al cargar la configuración.", err);
      mount();
      els.overlay.hidden = false;
      document.body.style.overflow = "hidden";
      showError("No se pudo cargar la configuración del buscador (hp-search-config.json). Puedes consultar directamente con un agente.");
      showTypeStep();
    });
  }

  function close() {
    if (els.overlay) {
      els.overlay.hidden = true;
      document.body.style.overflow = "";
    }
  }

  /* ------------------------------------------------------------------ *
   * Eventos — todo envuelto en try/catch: un error nunca deja un botón
   * muerto, siempre se ve en pantalla.
   * ------------------------------------------------------------------ */
  function wireEvents(wrap) {
    wrap.addEventListener("click", function (e) {
      try {
        if (e.target.closest("[data-hp-qs-close]") || e.target === els.overlay) {
          close();
          return;
        }

        var typeBtn = e.target.closest("[data-hp-qs-type]");
        if (typeBtn) {
          state.productType = typeBtn.getAttribute("data-hp-qs-type");
          state.brandKey = null;
          state.brandLabel = null;
          state.family = null;
          state.wattage = null;
          trackEvent(state.productType === "battery" ? "select_battery" : "select_charger", {});
          showTreeStep();
          return;
        }

        var changeType = e.target.closest("[data-hp-qs-change-type]");
        if (changeType) {
          resetState();
          showTypeStep();
          return;
        }

        var brandChip = e.target.closest("[data-hp-qs-brand]");
        if (brandChip) {
          state.brandKey = brandChip.getAttribute("data-hp-qs-brand");
          state.brandLabel = brandChip.getAttribute("data-hp-qs-brand-label");
          state.family = null;
          state.wattage = null;
          trackEvent("select_brand", { product_type: state.productType, brand: state.brandKey });
          renderBrands();
          renderDetail();
          return;
        }

        var familyChip = e.target.closest("[data-hp-qs-family]");
        if (familyChip) {
          state.family = familyChip.getAttribute("data-hp-qs-family");
          trackEvent("select_family", { brand: state.brandKey, family: state.family });
          renderDetail();
          return;
        }

        var wattageChip = e.target.closest("[data-hp-qs-wattage]");
        if (wattageChip) {
          state.wattage = wattageChip.getAttribute("data-hp-qs-wattage");
          trackEvent("select_wattage", { brand: state.brandKey, wattage: state.wattage });
          renderDetail();
          return;
        }

        if (e.target.closest("[data-hp-qs-search]") && !e.target.closest("[data-hp-qs-search]").hasAttribute("disabled")) {
          runSearch();
          return;
        }

        if (e.target.closest("[data-hp-qs-whatsapp]")) {
          openWhatsapp(!els.results.hidden && !els.noResults.hidden);
          return;
        }

        if (e.target.closest("[data-hp-qs-back-to-form]")) {
          showTreeStep();
          return;
        }

        if (e.target.closest("[data-hp-qs-view-all]")) {
          browseCategory();
          return;
        }

        if (e.target.closest("[data-hp-qs-upload-remove]")) {
          clearPhoto();
          return;
        }
      } catch (err) {
        console.error("HP LAB Quick Search: error al procesar un click.", err);
        showError("Ocurrió un error inesperado (" + (err && err.message ? err.message : err) + "). Puedes consultar con un agente mientras lo revisamos.");
      }
    });

    wrap.addEventListener("input", function (e) {
      try {
        var field = e.target.closest("[data-hp-qs-field]");
        if (field) {
          state[field.getAttribute("data-hp-qs-field")] = field.value;
        }
      } catch (err) {
        console.error("HP LAB Quick Search: error al guardar un campo.", err);
      }
    });

    if (els.uploadInput) {
      els.uploadInput.addEventListener("change", function () {
        try {
          if (els.uploadInput.files && els.uploadInput.files[0]) handlePhotoFile(els.uploadInput.files[0]);
        } catch (err) {
          console.error("HP LAB Quick Search: error al leer la foto.", err);
        }
      });
    }
    if (els.uploadZone) {
      ["dragenter", "dragover"].forEach(function (evt) {
        els.uploadZone.addEventListener(evt, function (e) { e.preventDefault(); els.uploadZone.setAttribute("data-dragover", "true"); });
      });
      ["dragleave", "drop"].forEach(function (evt) {
        els.uploadZone.addEventListener(evt, function (e) { e.preventDefault(); els.uploadZone.setAttribute("data-dragover", "false"); });
      });
      els.uploadZone.addEventListener("drop", function (e) {
        try {
          var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
          if (file) handlePhotoFile(file);
        } catch (err) {
          console.error("HP LAB Quick Search: error al soltar la foto.", err);
        }
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && els.overlay && !els.overlay.hidden) close();
    });
  }

  /* ------------------------------------------------------------------ *
   * Disparador global — cualquier [data-hp-quick-search-trigger] en
   * cualquier página abre el buscador, sin wiring adicional.
   * ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    try {
      var trigger = e.target.closest("[data-hp-quick-search-trigger]");
      if (trigger) {
        e.preventDefault();
        open();
      }
    } catch (err) {
      console.error("HP LAB Quick Search: error al abrir desde un disparador.", err);
    }
  });

  function init() {
    var bootstrap = document.querySelector("[data-hp-quick-search-config]");
    if (!bootstrap) return;
    settings.whatsappNumber = bootstrap.getAttribute("data-whatsapp-number") || "";
    settings.configUrl = bootstrap.getAttribute("data-config-url") || "";
    settings.batteryIconUrl = bootstrap.getAttribute("data-battery-icon-url") || "";
    settings.chargerIconUrl = bootstrap.getAttribute("data-charger-icon-url") || "";
    mount();
  }

  document.addEventListener("DOMContentLoaded", init);

  window.HPQuickSearch.open = open;
  window.HPQuickSearch.openWithPrefill = openWithPrefill;
  window.HPQuickSearch.close = close;
})();
